



















import {Vue,Component} from "vue-property-decorator";
import {RealTimeInfo} from "@/entity/RealTimeInfo";
import {getModule} from "vuex-module-decorators";
import {RealTimeInfoStore} from "@/store/RealTimeInfoStore";
import {UserInfoEntity} from "@/entity/UserInfoEntity";
import {RealTimeInfoReqDto} from "@/dto/RealTimeInfoReqDto";
import  {RouteConfig} from "vue-router";
import {UserInfoEntityDto} from "@/dto/UserInfoEntityDto";
import {AuthStore} from "@/oauth/AuthStore";
import {SecurityUtils} from "@/oauth/SecurityUtils";
import RealTimeInfoReq from "@/dto/RealTimeInfoReq";
import {CompanyInfo} from "@/entity/CompanyInfo";
Component.registerHooks([
  "beforeRouteEnter"
])
@Component({
  name: "RealTimeInfoView"
})
export default class RealTimeInfoView extends Vue{
  private realInfo: RealTimeInfo = new RealTimeInfo();
  private rs = getModule(RealTimeInfoStore)
  private su = SecurityUtils
  private toPath = 'KeShangSelect'
  async created(){
    const infoReal=JSON.parse(localStorage.getItem('infoReal') as string);
    if(this.rs.realInfos===null || !(this.rs.realInfos.length > 0)){
      /*
     let demo1: UserInfoEntity = JSON.parse(localStorage.getItem("demo1") as string);
     console.log('------')
      if(demo1===undefined||demo1===null){
        await this.getRealInfo()
        demo1= JSON.parse(localStorage.getItem("demo1") as string);
      }
       */
      const companyInfo = JSON.parse(localStorage.getItem("selectedCompanyInfo") as  any) as CompanyInfo;
      const realTimeInfoReq: RealTimeInfoReq = new RealTimeInfoReq();
      realTimeInfoReq.userName = this.su.getLoginUser().username;
      realTimeInfoReq.companyId = companyInfo.companyId as string;
      realTimeInfoReq.infoType=infoReal.infoType;
      realTimeInfoReq.page=1;
      realTimeInfoReq.size=infoReal.size;
      const  page=await RealTimeInfoReqDto.queryRealList(realTimeInfoReq)
      this.rs.setCurrentRealInfos(page.content)
    }
    (this.realInfo as any) = this.rs.realInfos.find(value => {
      return value.id === Number(this.$route.params.id)
    })
  }
  async getRealInfo(){
    const userInfoEntity = new UserInfoEntity()
    userInfoEntity.userName = this.su.getLoginUser().username
    const identity = await UserInfoEntityDto.selectCompanyInfo(userInfoEntity)
    if(identity!==null && identity.length>0) {
      localStorage.setItem("demo1", JSON.stringify(identity[0]));
    }else{
      const useinfo: UserInfoEntity=new UserInfoEntity();
      useinfo.userName=this.su.getLoginUser().username;
      localStorage.setItem("demo1", JSON.stringify(useinfo));
    }
  }
  beforeRouteEnter(to: RouteConfig,from: RouteConfig,next: Function){
    console.log(from.path);
    if(from.path === "/RealTimeInfoList"){
        next((vm: any)=>{
          vm.toPath = 'RealTimeInfoList'
        })
    }
    next()
  }
  mounted(){
   this.setImageStyle()
  }
  updated(){
   this.setImageStyle()
  }
  setImageStyle(){
    const imagArray = document.querySelectorAll("img")
    for (const image2 of imagArray){
      image2.style.width = "100%";
      if(image2.src.substring(4,5)!=='s'){
        image2.src='https'+image2.src.substring(4)
      }
    }
  }
  fanhui(){
    this.$router.push({name: this.toPath})
  }
  refresh() {
    setTimeout(() => {
      location.reload();
      // this.$router.push({name:'refresh'})
    }, 1000)
  }
}
